import axios from 'axios';
import React, { useState } from 'react';
import { Card, Button, Modal, Form, Alert } from 'react-bootstrap';

export default function Deactivate(){
  const [show, setShow] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    reason: '',
    comments: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    try {
      await axios.post(
        "https://api.dremerz.net/api/DZ_8925_VillageMilkPartner_Deactivation_Account_AllRequests",
        {
          name: formData.name,
          mobile: formData.mobile,
          reason: formData.reason,
          comments: formData.comments
        }
      );

      setSubmitted(true);
      setShow(false);
      
      setFormData({
        name: '',
        mobile: '',
        reason: '',
        comments: ''
      });
    } catch (error) {
      console.error("Error :", error);
    }
}

  return (
    <Card className="shadow-soft border border-danger">
      <Card.Body>
        <h3 className="fw-bold text-danger">Deactivate Account</h3>
        <Alert variant="warning" className="small">
          Deactivating permanently removes your profile and delivery history. This action cannot be undone.
        </Alert>
                {submitted && (
          <Alert variant="success" className="mt-3 small mb-0">
            <strong>Deactivation Request Submitted Successfully!</strong><br />
            <strong>Name:</strong> {formData.name}<br />
            <strong>Mobile:</strong> {formData.mobile}<br />
            <strong>Reason:</strong> {formData.reason === 'policy' ? 'Policy/contract change' : 
                                   formData.reason === 'schedule' ? 'Schedule issues' : 
                                   formData.reason === 'payout' ? 'Payout concerns' : 
                                   formData.reason === 'other' ? 'Other' : ''}<br />
            {formData.comments && <><strong>Comments:</strong> {formData.comments}<br /></>}
            <br />
            Our support will contact you at your registered email/phone. You can also reach us at
            <strong> carevillagemilk@gmail.com</strong> or <strong>8960060092</strong>.
          </Alert>
        )}

        <Form onSubmit={(e)=>{e.preventDefault(); setShow(true);}}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control 
              type="text" 
              name="name"
              value={formData.name}
              onChange={handleChange}
              required 
              placeholder="Enter your full name" 
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Mobile Number</Form.Label>
            <Form.Control 
              type="tel" 
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              required 
              placeholder="Enter your mobile number" 
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Reason</Form.Label>
            <Form.Select 
              required 
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              aria-label="Reason"
            >
              <option value="">Select a reason</option>
              <option value="policy">Policy/contract change</option>
              <option value="schedule">Schedule issues</option>
              <option value="payout">Payout concerns</option>
              <option value="other">Other</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Additional Comments</Form.Label>
            <Form.Control 
              as="textarea" 
              rows={3} 
              name="comments"
              value={formData.comments}
              onChange={handleChange}
              placeholder="Tell us more (optional)" 
            />
          </Form.Group>
          <div className="d-flex gap-2">
            <Button type="submit" variant="danger" className="btn-sm-tight">Request Deactivation</Button>
            <Button variant="outline-secondary" href="/">Cancel</Button>
          </div>
        </Form>

        <Modal show={show} onHide={()=>setShow(false)} centered>
          <Modal.Header closeButton><Modal.Title>Confirm Deactivation</Modal.Title></Modal.Header>
          <Modal.Body>
            This will permanently disable your access. Are you sure you want to proceed?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>setShow(false)}>No, go back</Button>
            <Button variant="danger" onClick={handleSubmit}>Yes, deactivate</Button>
          </Modal.Footer>
        </Modal>
      </Card.Body>
    </Card>
  );
}